import axios from 'axios'
import { fromTo } from '@quero/from-to'
import rollbar from '~/assets/js/services/rollbar-adapter'
import gambitLeadDictionary from '~/assets/data/from-to/gambit-lead-dictionary'

const env = process.env.NUXT_CONFIG_ENV ||
  process.env.NODE_ENV ||
  'development'

const API_URL = {
  development: 'https://gambit-homolog.quero.space/api/',
  staging: 'https://gambit-homolog.quero.space/api/',
  production: 'https://gambit.querobolsa.com.br/api/',
}[env]

const axiosClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-type': 'application/json' },
  withCredentials: true,
})

const cleanParams = (params) => {
  for (const key in params) {
    if (params[key] === null || params[key] === undefined || params[key] === '') {
      delete params[key]
    }
  }
}

export async function sendTrackingEvent (trackType, trackingParams, route = null) {
  const { isBot, isFromHq } = trackingParams

  const pageData = {
    visitable_path: route?.path,
    ...route?.query,
  }

  const trackingData = {
    ...pageData,
    ...trackingParams,
    event: trackType,
    system_code: process.env.NUXT_ENV_GAMBIT_SYSTEM_ID,
  }

  if (isBot || isFromHq) return

  cleanParams(trackingData)

  await axiosClient.post('/events', trackingData)
    .catch((error) => {
      rollbar.error('[EventTracker]', error)
      throw error
    })
}

export async function sendLead ($gtm, payload) {
  // still send event to dataLayer to be processed by GTM as there are still
  // other tags that use this event.
  $gtm.push({
    ...payload,
    event: 'New Lead Received',
  })

  await sendTrackingEvent('lead', fromTo(payload, gambitLeadDictionary))
}
